import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { ABService, ApiService, EventsService, PaymentService, ScriptLoaderService, SeoService, StorageService, UtilService, VariablesService } from './shared/services';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { environment } from 'src/environments/environment';
import { httpInterceptor } from './shared/services/http-inter/http-inter.interceptor';
import { LazyBugsnagErrorHandler } from './shared/error-handler/error-handler.module';

const Services = [
  ABService,
  ApiService,
  EventsService,
  PaymentService,
  ScriptLoaderService,
  SeoService,
  StorageService,
  UtilService,
  VariablesService
];

const sharedModules = [
  MatDialogModule,
  MatSnackBarModule,
  MatSelectModule,
  MatBottomSheetModule
]

export const ERROR_HANDLER_PROVIDER = environment.production ? [{ provide: ErrorHandler, useClass: LazyBugsnagErrorHandler }] : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([httpInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    ...ERROR_HANDLER_PROVIDER,
    ...Services,
    ...sharedModules
  ]
};
